import { isNonNullable, nonNullable } from 'lib/array/arrayUtils'
import { findByTwoLetterCode } from 'lib/insurance/insuranceCountries'

function isCruiseOfferSnapshot(offer: App.CruiseOffer | App.Cruises.CruiseOfferSnapshot): offer is App.Cruises.CruiseOfferSnapshot {
  return 'bookingId' in offer
}

function mapCountryCodesFromItineraries(itineraries: Array<App.CruiseItineraryItem | App.Cruises.CruiseOfferItinerarySnapshot> | undefined) {
  if (!itineraries) return []
  return itineraries.flatMap(itinerary => itinerary.port?.countryCode).filter(isNonNullable)
}

export const getItineraryCountries = (offer: App.CruiseOffer | App.Cruises.CruiseOfferSnapshot) => {
  const countryCodes: Array<string> = []
  if (isCruiseOfferSnapshot(offer)) {
    countryCodes.push(...mapCountryCodesFromItineraries(offer.itineraries))
  } else {
    countryCodes.push(...mapCountryCodesFromItineraries(offer.itinerary))
  }
  return nonNullable(countryCodes.map(countryCode => findByTwoLetterCode(countryCode)))
}
